import { authClient } from './api';
import { ENDPOINTS } from './constants';
import { AUTH_BASE_URL, } from "../config";
import axios from "axios";

const getAbsoluteAuthUrl = (path) => {
  const baseUrl =  AUTH_BASE_URL;
  return baseUrl ? `${baseUrl}${path}` : path;
};

const isLocalAuthBase = () =>
  typeof AUTH_BASE_URL === "string" &&
  (AUTH_BASE_URL.includes("127.0.0.1") || AUTH_BASE_URL.includes("localhost"));

export const authService = {
  signUp: async (userData) => {
    try {
      const response = await authClient.post(ENDPOINTS.AUTH.REGISTER, userData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  googleSignUp: async (googleData) => {
    try {
      const response = await authClient.post(
        ENDPOINTS.AUTH.REGISTER_GOOGLE,
        googleData
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  googleSignIn: async (googleData) => {
    try {
      const response = await authClient.post(
        ENDPOINTS.AUTH.LOGIN_GOOGLE,
        googleData
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  sendOTP: async (otpData) => {
    try {
      const response = await authClient.post(
        `${ENDPOINTS.AUTH.SEND_VERIFICATION}/${otpData.userId}`,
        otpData
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  verifyOTP: async (verificationData) => {
    try {
      const response = await authClient.post(ENDPOINTS.AUTH.VERIFY_CODE, {
        // email: verificationData.email,
        verifycode: verificationData.code,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateUser: async (userType) => {
    try {
      const response = await authClient.put(ENDPOINTS.USER.UPDATE_TYPE, {
        user_type: userType,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  login: async (credentials) => {
    try {
      const response = await authClient.post(ENDPOINTS.AUTH.LOGIN, credentials);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  forgotPassword: async (emailData) => {
    try {
      const response = await authClient.post(
        ENDPOINTS.AUTH.FORGOT_PASSWORD,
        emailData
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  resetPassword: async (resetData) => {
    try {
      const response = await authClient.post(ENDPOINTS.AUTH.RESET_PASSWORD, {
        verify_token: resetData.token,
        password: resetData.password,
        confirmPassword: resetData.password,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getUserInfo: async () => {
    try {
      const token = localStorage.getItem("dockporter_token");
      if (!token) {
        console.warn("No auth token found for getUserInfo");
        return null;
      }

      const response = await axios.get(
        getAbsoluteAuthUrl(ENDPOINTS.AUTH.GET_USER_INFO),
        {
          headers: { Authorization: token },
          timeout: 10000, // 10 second timeout
        }
      );
      return response.data;
    } catch (error) {
      console.warn("getUserInfo failed:", error.message);
      return null; // Return null instead of throwing
    }
  },
  refreshToken: async (refreshToken) => {
    try {
      const response = await authClient.post(ENDPOINTS.AUTH.REFRESH, {
        refresh_token: refreshToken
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  postUserInfo: async (userInfo) => {
    try {
      if (isLocalAuthBase()) {
        return null;
      }

      const response = await authClient.put(ENDPOINTS.AUTH.POST_USER_INFO, {
        country: userInfo.country,
        codeName: userInfo.countryCode,
        network: userInfo.as,
        city: userInfo.city,
        ip: userInfo.query,
        region: userInfo.region,
        state: userInfo.regionName,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};